import { lazy, Suspense } from "react";
import { useLayout } from "@agentsaas/ui";
import { useThemePref, resolveTheme } from "../app/theme";
import { Loading } from "../layout/Loading";
import type { DiffProps, EditorProps } from "./editor-types";

// 按需加载：桌面 Monaco，手机 CodeMirror（doc/dev_plan.md §1.2）
const Monaco = lazy(() => import("./monaco"));
const MonacoDiff = lazy(() => import("./monaco").then((m) => ({ default: m.MonacoDiff })));
const CodeMirror = lazy(() => import("./codemirror"));
const CodeMirrorDiff = lazy(() => import("./codemirror").then((m) => ({ default: m.CodeMirrorDiff })));

function useDark() {
  const [pref] = useThemePref();
  return resolveTheme(pref) === "dark";
}

export function CodeEditor(props: Omit<EditorProps, "dark">) {
  const mobile = useLayout() === "mobile";
  const dark = useDark();
  const C = mobile ? CodeMirror : Monaco;
  return (
    <Suspense fallback={<Loading />}>
      <C {...props} dark={dark} />
    </Suspense>
  );
}

export function DiffView(props: Omit<DiffProps, "dark">) {
  const mobile = useLayout() === "mobile";
  const dark = useDark();
  const C = mobile ? CodeMirrorDiff : MonacoDiff;
  return (
    <Suspense fallback={<Loading />}>
      <C {...props} dark={dark} />
    </Suspense>
  );
}
